const gsapFooterAccordion = () => {
	const triggers = document.querySelectorAll(".accordion-single__trigger");
  
	// Function to check if we're on mobile/tablet (1024px or smaller)
	const isMobile = () => window.innerWidth <= 1024;
  
	triggers.forEach((trigger) => {
	  const parent = trigger.parentElement;
	  const menuGroup = parent.querySelector(".footer__menu-group");
	  const menuLinks = menuGroup ? menuGroup.querySelectorAll("a") : [];
  
	  // Function to manage inert attribute on menu links
	  const setLinksInert = (isInert) => {
		menuLinks.forEach((link) => {
		  if (isInert) {
			link.setAttribute("inert", "");
		  } else {
			link.removeAttribute("inert");
		  }
		});
	  };
  
	  // Function to set up accordion based on screen size
	  const setupAccordion = () => {
		if (menuGroup) {
		  if (isMobile()) {
			// Mobile: Set up accordion functionality
			gsap.set(menuGroup, {
			  height: 0,
			  overflow: "hidden",
			});
			// Make links inert when closed on mobile
			setLinksInert(true);
		  } else {
			// Desktop: Always show menu groups
			gsap.set(menuGroup, {
			  height: "auto",
			  overflow: "visible",
			});
			parent.classList.remove("accordion-open");
			// Make links accessible on desktop
			setLinksInert(false);
		  }
		}
	  };
  
	  // Initial setup
	  setupAccordion();
  
	  const handleAccordion = () => {
		if (!isMobile()) return;
  
		const isOpen = parent.classList.contains("accordion-open");
  
		if (isOpen) {
		  // Close accordion
		  parent.classList.remove("accordion-open");
  
		  if (menuGroup) {
			gsap.to(menuGroup, {
			  height: 0,
			  duration: 0.4,
			  ease: "power2.inOut",
			  onComplete: () => {
				// Make links inert when closed
				setLinksInert(true);
				// Refresh both ScrollSmoother and ScrollTrigger after animation completes
				requestAnimationFrame(() => {
				  if (typeof ScrollSmoother !== "undefined") {
					ScrollSmoother.refresh(true);
				  }
				  if (typeof ScrollTrigger !== "undefined") {
					ScrollTrigger.refresh();
				  }
				});
			  },
			});
		  }
		} else {
		  // Open accordion
		  parent.classList.add("accordion-open");
		  // Make links accessible when opening
		  setLinksInert(false);
  
		  if (menuGroup) {
			// Get the natural height
			gsap.set(menuGroup, { height: "auto" });
			const autoHeight = menuGroup.offsetHeight;
			gsap.set(menuGroup, { height: 0 });
  
			gsap.to(menuGroup, {
			  height: autoHeight,
			  duration: 0.4,
			  ease: "power2.inOut",
			  onComplete: () => {
				// Set to auto height for responsiveness
				gsap.set(menuGroup, { height: "auto" });
				// Refresh both ScrollSmoother and ScrollTrigger after animation completes
				requestAnimationFrame(() => {
				  if (typeof ScrollSmoother !== "undefined") {
					ScrollSmoother.refresh(true);
				  }
				  if (typeof ScrollTrigger !== "undefined") {
					ScrollTrigger.refresh();
				  }
				});
			  },
			});
		  }
		}
	  };
  
	  trigger.addEventListener("click", () => {
		// Only handle accordion on mobile/tablet
		handleAccordion();
	  });
  
	  trigger.addEventListener("keydown", (e) => {
		if (e.key === "Enter" || e.key === " ") {
		  handleAccordion();
		}
	  });
  
	  // Listen for window resize to handle responsive behavior
	  window.addEventListener("resize", () => {
		setupAccordion();
	  });
	});
  };
  
  if (document.readyState !== "loading") {
	gsapFooterAccordion();
  } else {
	document.addEventListener("DOMContentLoaded", gsapFooterAccordion);
  }